<div>
  <app-topbar (changeMenuOption)="changeMenuOption($event)"></app-topbar>
  <app-sidebar #sidebar></app-sidebar>
</div>

